module.exports = __webpack_public_path__ + "static/media/day22.workshop.7dd8452a.md";